module.exports = __webpack_public_path__ + "static/service_1-f657828aa5c38706fc41a2deaa5a30d6.jpg";